<template>
  <div id="playerPage" class="page white" ref="playerPage">
    <el-container class="content-aside workspace">
      <el-main class="cpl-main workspace">
        <div class="options">
          <el-row :gutter="20">
            <!-- Search Bar -->
            <el-col :span="24" class="search-col">
              <div class="workspace search">
                <player-search-bar
                  :ref="'playerSearchBar'"
                  :presentPlayerListProp="playerList"
                  :presentPlayerListByBatchProp="playerList.batchHistory"
                  :playerSelectedFromParentProp="playerSelection"
                  :tagsProp="selectedTagsFromSlider"
                  @player-search-bar-change="handlePlayerSearchBarChange($event)">
                </player-search-bar>
              </div>
            </el-col>
          </el-row>
        </div>

        <tag-slider :accessorComponentProp="'playerPage'"
          :refreshTagSliderProp="refreshTagSlider"
          @tag-slider-change="handleTagSliderChange($event)">
        </tag-slider>

        <!-- Content -->
        <el-row :gutter="0" class="main-content-row hide-scrollbar player-list-row workspace content-start" id="playerListContainer">
          <!-- Players -->
          <draggable
            v-for="(playerItem, index) in playerList.itemsToShow"
            v-bind="sortDraggableOptions"
            class="el-col el-col-8 player-item"
            tag="div"
            item-key="serialNumber"
            ghost-class="sortable-ghost"
            :id="playerItem.serialNumber"
            :key="index"
            :list="[playerItem]"
            :group="{ name: 'tags-shared', pull: false, put: true }"
            @add="handleTagDraggableAdd($event, playerItem)"
          >
            <template #item="{ element: item }">
              <div
                :id="item.serialNumber"
                :class="{
                  'is-selected': item._edit && item._edit.selected,
                  'show-player-config-droppable': configFileDragging,
                  'iBX410W' :  isDeviceTypeiBX410W(item),
                  'iBX440' :  isDeviceTypeiBX440(item)
                }"
                :span="8">

                <!-- Player Card content -->
                <div :class="['content workspace', {'is-selected': (item._edit && item._edit.selected)}]">
                  <div class="player-fixed">
                    <!-- Players preview/icon -->
                    <div :class="['player-preview', 'section-wrapper', {'is-selected': (item._edit && item._edit.selected)}]">
                      <div class="image-and-icon">
                        <div :class="['check-icon', getStatusClassnameIcon(item)]"></div>

                        <img v-if="isDeviceTypeHMP300(item)" class="player-icon" src="@/static/icons/300_1k.png"/>
                        <img v-else-if="isDeviceTypeHMP350(item)" class="player-icon" src="@/static/icons/350_1k.png"/>
                        <img v-else-if="isDeviceTypeHMP400(item)" class="player-icon" src="@/static/icons/400_1k.png"/>
                        <img v-else-if="isDeviceTypeHMP400W(item)" class="player-icon" src="@/static/icons/400W_1k.png"/>
                        <img v-else-if="isDeviceTypeDSOS(item)" class="player-icon" src="@/static/icons/dsos.png"/>
                        <img v-else-if="isDeviceTypeDiVA(item)" class="player-icon" src="@/static/icons/diva.png"/>
                        <img v-else-if="isDeviceTypeiBX440(item)" class="player-icon" src="@/static/icons/ibx440.png">
                        <img v-else-if="isDeviceTypeiBX410(item)" class="player-icon" src="@/static/icons/ibx410.png">
                        <img v-else-if="isDeviceTypeiBX410W(item)" class="player-icon" src="@/static/icons/ibx410W.png">
                        <img v-else class="player-icon" src="@/static/icons/dsos.png"/>
                      </div>
                    </div>

                    <!-- Show drop hover for tags drag and drop -->
                    <div class="drag-and-drop-hover"></div>

                    <!-- Player Name -->
                    <div class="player-name">
                      <!-- Name Txt -->
                      <div v-if="(!inlineEditName.isInputVisible && inlineEditName.serialNumber === item.serialNumber) ||
                        (inlineEditName.serialNumber !== item.serialNumber)"
                        @click="handleInlineEditNameClick($event, item, index)"
                        :class="['player-item-name']">{{item.name}}</div>

                      <!-- Edit Name Input -->
                      <el-input
                        id="player-edit-name-input"
                        class="edit-player-item-name"
                        v-if="inlineEditName.isInputVisible && inlineEditName.serialNumber === item.serialNumber"
                        :model-value="item.name"
                        @update:model-value="newValue => item.name = newValue"
                        :ref="`${item.serialNumber}-editName`"
                        size="mini"
                        @blur="handleInlineEditNameInputConfirm(item, index)"
                        @focus="$event.target.select()">
                      </el-input>
                    </div>

                    <!-- Player card cover -->
                    <div @click="handlePlayerCardOnClick($event, item, index)" class="cover player-item-cover"></div>

                    <!-- Handle player config upload -->
                    <el-upload
                      :id="`playerConfigFileUpload-${item.serialNumber}`"
                      :ref="`playerConfigFileUpload-${item.serialNumber}`"
                      :action="''"
                      :auto-upload="false"
                      :drag="true"
                      :multiple="false"
                      :show-file-list="false"
                      :on-change="handleUploadChange"
                      :http-request="handleUploadHttpRequest"
                      class="player-config-uploader">
                    </el-upload>
                  </div>
                  <div class="player-selected-icon"></div>
                </div>

                <!-- Player card delete icon -->
                <template v-if="enableDeletePlayerAction">
                  <div :class="['player-item-action-icon', { 'hover': hoverDeleteIcon }]"
                    @click="handleDeletePlayerIconClick"
                    @mouseover="hoverDeleteIcon = true"
                    @mouseout="hoverDeleteIcon = false">
                    <div class="delete icon"></div>
                  </div>
                </template>
              </div>
            </template>
          </draggable>
        </el-row>
      </el-main>

      <!-- Right Side -->
      <el-aside class="cpl-aside workspace">
        <player-menu
          :playerSetupSerial="serialNumber"
          :playerSelectionProp="playerSelection"
          :tagsSummaryProp="tagsSummary"
          :allLEDTagsProp="allLEDTags"
          v-on:PlayerAdded="handlePlayerAddedEvent"
          @player-menu-change="handlePlayerMenuOnChange($event)">
        </player-menu>

      </el-aside>

    </el-container>
  </div>
</template>

<script src="./player.js"></script>
<style lang="scss" src="./player.scss"></style>
